import { OrganisationPermissionConstants, OrganisationTypeConstants } from "../../../constants";
import { DeveloperSingleCardWithTabsTemplate } from "../../../templates";
import { useAuth } from "../../../useAuth";
import {
  getSettingsAuditHistoryRoute,
  getSettingsDocumentTypesRoute,
  getSettingsProjectAccessRoute,
  getUserSettingsOrganisationRoute,
  getUserSettingsRoute,
} from "../../../utils/routes";

const Settings = (): JSX.Element => {
  const { hasPermission, currentUserType } = useAuth();

  return (
    <div>
      <DeveloperSingleCardWithTabsTemplate
        activeElement="Settings"
        pageTitle="Settings"
        tabsList={
          hasPermission(OrganisationPermissionConstants.READ_ORGANISATION_USERS)
            ? [
                { route: getUserSettingsRoute(currentUserType), label: "Users" },
                { route: getUserSettingsOrganisationRoute(currentUserType), label: "Organisation" },
                { route: getSettingsAuditHistoryRoute(currentUserType), label: "Audit history" },
                { route: getSettingsProjectAccessRoute(currentUserType), label: "Project access" },
                { route: getSettingsDocumentTypesRoute(currentUserType), label: "Document types" },
              ]
            : [
                { route: getUserSettingsOrganisationRoute(currentUserType), label: "Organisation" },
                { route: getSettingsAuditHistoryRoute(currentUserType), label: "Audit history" },
                { route: getSettingsProjectAccessRoute(currentUserType), label: "Project access" },
                { route: getSettingsDocumentTypesRoute(currentUserType), label: "Document types" },
              ]
        }
        currentUserType={OrganisationTypeConstants.DEVELOPMENT_MANAGER}
      />
    </div>
  );
};

export default Settings;
